import '@/util/array.util'

import Vue from 'vue'

Vue.config.devtools = process.env.VUE_APP_ENV !== 'production'
Vue.config.productionTip = false

import App from './App'
import router from './router'

import Assets from '@/assets'
import ThirdParty from '@/third-party'
import Filters from '@/filters'
import Mixins from '@/mixins'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import Core from '@/components/Core'
import Solicitudes from '@/components/Solicitudes'

Vue.use(Assets)
Vue.use(ThirdParty)
Vue.use(Filters)
Vue.use(Mixins)
Vue.use(Toast)
Vue.use(Core)
Vue.use(Solicitudes)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_ENABLE_TAILWIND_DEBUG_SCREENS === 'true') {
  document.body.classList.add('debug-screens')
}
